import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TabContent = (props) => {
  const { children, checked, className } = props;
  const contentStyling = classNames(
    className,
    'tab-content__section',
    { selected: checked }
  );
  return (<div className={contentStyling}>{children}</div>);
};
TabContent.displayName = 'TabContent';

TabContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired,
  className: PropTypes.string,
  checked: PropTypes.bool
};

TabContent.defaultProps = {
  checked: false,
  className: null
};

export default TabContent;
